module.exports = __webpack_public_path__ + "static/media/new_music.fb1a421d.png";